const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0'
  },
  dropdown: {
    containerWithLabel: {
      marginBottom: 10
    }
  }
}

export default styles
